import React from 'react';
import { Navigate } from 'react-router-dom';
import usePermissions from '../hooks/usePermissions';

export function RootRedirect() {
  const { canRead, loading } = usePermissions();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-[#EBF0FA] border-t-[#3245a4] rounded-full animate-spin"></div>
          <p className="text-[#3245a4] font-semibold animate-pulse">Cargando...</p>
        </div>
      </div>
    );
  }

  // Evaluamos en orden de prioridad a dónde enviar al usuario
  if (canRead('dashboard')) return <Navigate to="/dashboard" replace />;
  if (canRead('customers')) return <Navigate to="/customers" replace />;
  if (canRead('packages')) return <Navigate to="/reservations" replace />;
  if (canRead('cruises')) return <Navigate to="/cruises" replace />;

  // En caso extremo que no tenga acceso a nada de lo anterior, a la vista default
  return <Navigate to="/reservations" replace />;
}
